<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button color="light" (click)="cancel()">Sluiten</ion-button>
    </ion-buttons>
    <ion-title>Schoonmaak</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="confirm()" [strong]="true">Opslaan</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-no-padding">

  <ion-list lines="full">
    @for(task of maintenanceTasks; track task.id){
    <ion-item lines="full">
      <ion-checkbox style="margin-right: 1rem;" (ionChange)="checkTask(task, $event)" /> {{ task.name }}
    </ion-item>
    }
  </ion-list>

</ion-content>